var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'is-required': _vm.field.required
  }},[_c('el-input',_vm._b({ref:_vm.field.name,class:('el-textarea--no-resize-icon',
      {
        'is-error': !!_vm.field.error,

        'no-label': !!_vm.$attrs['no-label'],
        'communication-textarea': _vm.type == 'communication'
      }),attrs:{"name":_vm.field.name,"required":_vm.field.required || _vm.required,"placeholder":_vm.field.placeholder || _vm.$attrs.placeholder,"disabled":_vm.field.disabled,"readonly":_vm.field.readonly,"type":"textarea","maxlength":Number(_vm.field.maxlength || _vm.field.len || _vm.$attrs.maxlength),"autosize":_vm.type == 'communication' ? { minRows: 1, maxRows: 10 } : true},nativeOn:{"change":function($event){return _vm.changeValue.apply(null, arguments)},"input":function($event){return _vm.changeValue.apply(null, arguments)}},model:{value:(_vm.localModel),callback:function ($$v) {_vm.localModel=$$v},expression:"localModel"}},'el-input',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }